import React from "react";
import { Button, type ButtonProps } from "ui/button";
import { trackSignupClicked } from "./utils";

type SignupButtonProps = {
  /**
   * Button text.
   *
   * @default "Get started"
   */
  text?: string;

  /**
   * Button variant.
   *
   * @default "primary"
   */
  variant?: ButtonProps["variant"];
};

/**
 * Provides a button-styled link to the sign-up page. Automatically tracks the sign-up event and current page URL.
 */
export function SignupButton({ text = "Get started", variant = "primary" }: SignupButtonProps) {
  return (
    <Button
      hasRightChevron={variant === "primary"}
      variant={variant}
      href="https://app.hightouch.com/signup"
      target="_blank"
      onClick={trackSignupClicked}
    >
      {text}
    </Button>
  );
}
